import { Atribucion } from './../../models/atribucion';
import { AtribucionService } from '../../services/atribucion.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
@Component({
  selector: 'app-atribucion',
  templateUrl: './atribucion.component.html',
  styleUrls: ['./atribucion.component.css']
})

export class AtribucionComponent implements OnInit, OnDestroy {

  breadCrumbItems = [{label: 'Formulación Planes'}, {label: 'Elementos'}, {label: 'Atribuciones', active: true}];

  public formAtribucion!:UntypedFormGroup;
  public formSubmitted= false;
  public ipAddress!:string;
  public buffer:any;
  public currentAmbiente:any;
  public idSprUsuarioApp:any;
  public nombreUnidad!:any;
  public idSprAmbiente!:number;
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public dataApp: any[] = [];
  public contador = 2000;
  public textoAreaValue = '';
  public idSprNivel: number = 0;
  public idSprNivelN1 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_1;
  readonly constant = ConstantsCatalogosIdService;

  public nameModal: string = 'modalNewEdit'
  nameApp = 'ATRIBUCIONES';
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

 //Almacena el usuario actual disponible en Redux
  currentUserRedux: UsuarioRedux = null;


 @ViewChild(DataTableDirective, { static: false })
 dtElement: DataTableDirective;

 isDtInitialized: boolean = false;

 @Input() set inputAmbiente(idInputAmbiente: any) {
  this.idSprAmbiente = idInputAmbiente;
}

  constructor(
    private fb: FormBuilder,
    private atribucionService:AtribucionService,
    private alertService:AlertService,
    private ip:IpPublicService,
    public modal: ModalService,
    private store: Store<AppState>,
    ) {
      this.buffer = localStorage.getItem('currentUser');
      this.currentAmbiente = JSON.parse(this.buffer);
      //this.currentUser = JSON.parse(this.buffer);
      this.nombreUnidad = this.currentAmbiente.nombreUnidad;     
      this.selectItems = [
        { value: 1, label: 'Activo' },
        { value: 2, label: 'Inactivo' },
      ];
    }

    get atribucionForm() {
      return this.formAtribucion.controls;
    }

    setDataTable() {
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        destroy: true,
        language: {
          //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
      };
    }

    setForm() {
    this.formAtribucion = this.fb.group({
     idSprAtribucion: [],
     idSprAmbiente: [],
     nombre: ['',[Validators.required]],
     descripcion: [],
     estado: ['', [Validators.required]],
    });
    this.formAtribucion.patchValue({
      estado: this.selectItems[0].value,
    });
  }
  initApp() {

    this.listDataApp(this.idSprAmbiente);
    this.setDataTable();
    this.setForm();
    }
  ngOnInit() {

    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel =  response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
    });

      this.store.select('usuarioApp').subscribe((response) => {
        this.currentUserRedux = response.currentUser;
        this.idSprUsuarioApp = response.currentUser.idSprUsuario;
  
      });
    this.validaNivel();
    this.getIpPublic();
    this.initApp(); 
  }

  validaNivel(){
    if (this.idSprNivel == this.idSprNivelN1) {
      this.nameApp = 'COMPETENCIAS';
      this.breadCrumbItems = [
        { label: 'Formulación Planes' },
        { label: 'Elementos' },
        { label: 'Competencias', active: true }
      ];
    } else {
      this.nameApp = 'ATRIBUCIONES';
      this.breadCrumbItems = [
        { label: 'Formulación Planes' },
        { label: 'Elementos' },
        { label: 'Atribuciones', active: false }
      ];
      }
  }


  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
    this.ipAddress = res.ip;
    });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  listDataApp(idSprAmbiente:any){ 
    this.atribucionService.list('?idSprAmbiente=' + idSprAmbiente)
    .subscribe(resp => {
     this.dataApp = resp;
     this.reDrawDataTable();
    });
   }

   reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSubmit() {
    this.formSubmitted = true;
    this.formAtribucion.value.usuario = this.idSprUsuarioApp;
    this.formAtribucion.value.ip = this.ipAddress;
    this.formAtribucion.value.idSprAmbiente = this.idSprAmbiente;
  
    if (!this.formAtribucion.invalid) {
      if (this.formAtribucion.value.idSprAtribucion == null) {
        this.listCatalogoExiste(this.formAtribucion.value.nombre);
      } else {
        if (this.listAtribucionExisteDiferente(this.formAtribucion.value.nombre, this.formAtribucion.value.idSprAtribucion)) {
          this.atribucionService.update(this.formAtribucion.value)
            .subscribe(
              resp => {
                this.initApp();
                this.modal.close();
                this.alertService.updateOk();
              },
              err => {
                this.alertService.updateError();
              }
            );
        }
      }
    } else {
      return;
    }
  }
  
  listCatalogoExiste(nombre: string) {
    for (let elemento of this.dataApp) {
      if (elemento.nombre === nombre) {
        this.alertService.warning(
          '¡Atención!',
          'Existe una atribución con el mismo nombre.'
        );
        return;
      }
    }
  
    // If no duplicate name found, proceed with creation
    this.atribucionService.create(this.formAtribucion.value)
      .subscribe(
        resp => {
          this.initApp();
          this.modal.close();
          this.alertService.createOk();
        },
        err => {
          this.alertService.createError();
        }
      );
  }

  listAtribucionExisteDiferente(nombre: any, idSprAtribucion: any) {
    let vector: any = [];
    let vectorFiltrado: any = [];
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    vector = this.dataApp;
    for (let elemento of vector) {
      if (elemento.idSprAtribucion !== idSprAtribucion) {
        vectorFiltrado.push(elemento);
      }
    }
    for (let elemento of vectorFiltrado) {
      if (elemento.nombre == nombresFin) {
        this.alertService.warning('¡Atención!',"Existe una atribución con el mismo nombre.");
        return false;
      }
    }
    return true;
  }

      edit(obj:Atribucion){
        this.openModal();
        this.formAtribucion.patchValue({
        idSprAtribucion: obj.idSprAtribucion,
        idSprAmbiente: obj.idSprAmbiente,
        nombre: obj.nombre,
        descripcion: obj.descripcion,
        estado: obj.estado,
        });
     }

 /********************CONTADOR DE CARACTER*******************/
 onKey(event: Event) {
  let maxLength = 2000;
  let strLength = this.textoAreaValue.length;
  let charRemain = maxLength - strLength;

  if (charRemain < 0) {
    document.getElementById("contador").innerHTML = '<span style="color: red;"> Ha superado el límite de ' + maxLength + ' characters</span>';
  } else {
    document.getElementById("contador").innerHTML = charRemain + ' caracteres restantes';
  }

  this.contador = charRemain; // Actualizar el contador cada vez que se pulsa una tecla
}
/************************************************************/


  delete(idRegister:number){
    this.modal.open('delete-atribucion');
   this.idDeleteRegister= idRegister;
  }


  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.atribucionService.delete(
        {"idSprAtribucion":this.idDeleteRegister,
        "usuario":this.idSprUsuarioApp,
        "delLog":"S",
        "ip":this.ipAddress
      }
      )
        .subscribe(resp => {
          this.initApp();
          this.modal.close()
         this.alertService.deleteOk();
        }, (err) => {
          this.alertService.deleteError();
        });
      }
  }

  // Modal Crear/editar
  openModal(){
    this.onResetForm();
    this.modal.open(this.nameModal);
    this.textoAreaValue = ''; // Restablecer el valor del ngModel a una cadena vacía
    this.contador = 2000; // Reiniciar el contador a 700 cada vez que se abre el modal
    this.onKey(null)

      }

// Resetear el formulario
    //################################################
    onResetForm() {
      this.formSubmitted = false;
      this.formAtribucion.reset();
  }
}


